import $ from 'jquery';

/**
 * button to show/hide menu
 *
 * @module group-button
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-01 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-12-02 using ChatGPT
 */

class GroupsButton {
  constructor(element) {
    this.$el = $(element);
    this.setupDefaults();
    this.setBinds();
    // Log removed: 'PracticeGroupButton : Initialized'
  }

  setupDefaults() {
    this.$menuButton = this.$el.find('.menuButton');
    // this.$menu = $('.groups-menu-module'); // Uncomment if needed
    this.$groupOverlay = this.$el.find('.groupOverlay');
  }

  setBinds() {
    this.$menuButton.on('click', () => this.handleMenuBtnClick());
  }

  handleMenuBtnClick() {
    this.$groupOverlay.toggleClass('open');
  }
}

export default GroupsButton;
